import appConfigStoreModule from '@core/@app-config/appConfigStoreModule'
import Vue from 'vue'
import Vuex from 'vuex'
import app from './app'
import * as getters from './getters'
import routes from './modules/routes'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    isOld: true,
    showNotification: false,
    token: '',
    info: window.localStorage.storeInfo ? JSON.parse(window.localStorage.storeInfo) : {},
    user: window.localStorage.user ? JSON.parse(window.localStorage.user) : {},
    version: window.localStorage.reload_data_v ? window.localStorage.reload_data_v : '',
    settings: {},
    permissions: window.localStorage.permissions ? JSON.parse(window.localStorage.permissions) : [],
    notifications: {},
    readConditionalReturnNotificationIds: [],
  },
  mutations: {
    storeNotifications(state, notifications) {
      const previous = state.notifications.conditional_return_notifications || []
      const incoming = notifications.conditional_return_notifications === undefined
        ? previous : notifications.conditional_return_notifications
      const notices = incoming.filter(notice => !state.readConditionalReturnNotificationIds.includes(notice.id))
      const hasNewNotice = notices.some(notice => !previous.some(old => old.id === notice.id))
      const wasOpen = state.showNotification
      state.notifications = { ...notifications, conditional_return_notifications: notices }
      const legacyPending = notifications.auths > 0 || notifications.tickets > 0 || notifications.manual_send_bills > 0
      state.showNotification = !notifications.silent && !!(legacyPending || (notices.length && (hasNewNotice || wasOpen)))
    },
    readConditionalReturnNotification(state, id) {
      if (!state.readConditionalReturnNotificationIds.includes(id)) state.readConditionalReturnNotificationIds.push(id)
      const notices = state.notifications.conditional_return_notifications || []
      state.notifications = {
        ...state.notifications,
        conditional_return_notifications: notices.filter(notice => notice.id !== id),
      }
      if (!state.notifications.conditional_return_notifications.length
        && !state.notifications.auths && !state.notifications.tickets && !state.notifications.manual_send_bills) {
        state.showNotification = false
      }
    },
    storeToken(state, token) {
      state.token = token
      state.isOld = false
      localStorage.setItem('token', token)
    },
    storeInfo(state, info) {
      state.info.dollar = info.dollar
      state.info.percent = info.percent
      localStorage.setItem('storeInfo', JSON.stringify(info))
    },
    storeUser(state, user) {
      state.user = user
      window.localStorage.setItem('user', JSON.stringify(user))
    },
    storeVersion(state, version) {
      state.version = version
      window.localStorage.setItem('reload_data_v', version)
    },
    storePermissions(state, permissions) {
      state.permissions = permissions
      window.localStorage.setItem('permissions', JSON.stringify(permissions))
    },
    logout(state) {
      state.notifications = {}
      state.readConditionalReturnNotificationIds = []
      state.showNotification = false
      state.token = ''
      state.user = {}
      state.info = {}
      state.permissions = []
      localStorage.clear()
    },
  },
  actions: {
    storeNotifications({ commit }, payload) {
      commit('storeNotifications', payload)
    },
  },
  getters,
  modules: {
    appConfig: appConfigStoreModule,
    app,
    routes,
  },
})
